import api from './index';
import { ApiResponse, Product, CartItem, Collection } from '../types';

export const shopifyApi = {
  /**
   * Get VIP products from Shopify
   * Optionally filter by collection handle
   */
  async getProducts(collection?: string): Promise<Product[]> {
    const params = collection ? { collection } : {};
    const response = await api.get<ApiResponse<{ products: Product[] }>>('/shopify/products', { params });

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to fetch products');
    }

    return response.data.data.products;
  },

  /**
   * Get available collections for the current user
   */
  async getCollections(): Promise<Collection[]> {
    const response = await api.get<ApiResponse<{ collections: Collection[] }>>('/shopify/collections');

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to fetch collections');
    }

    return response.data.data.collections;
  },

  /**
   * Create cart and get checkout URL
   */
  async createCart(items: CartItem[]): Promise<string> {
    const response = await api.post<ApiResponse<{ checkoutUrl: string }>>('/shopify/cart', {
      items,
    });

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to create cart');
    }

    return response.data.data.checkoutUrl;
  },
};

export default shopifyApi;
